module.exports = __webpack_public_path__ + "f025344639c23576554e39a67b2c55be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_6.jpg
// module id = 1785
// module chunks = 5